import { atom } from "recoil";
import { IContatoHistoricoEmpresaPosicao } from "../../commons/styleds/historicoProdissional";

export const contatoHistoricoEmpresaPosicoesAtom = atom<IContatoHistoricoEmpresaPosicao[]>({
  key: 'contatoHistoricoEmpresaPosicoes',
  default: [] as IContatoHistoricoEmpresaPosicao[],
})
